// src/data/comedians/hasan-minhaj.js

const base = {
  id: 'hasan-minhaj',
  slug: 'hasan-minhaj',
  name: 'Hasan Minhaj',
  birthYear: 1985,
  image: require('@/assets/images/img_Hasan_Minhaj.jpg'),
  famousWorks: [
    'Patriot Act with Hasan Minhaj (2018-2020)',
    'Homecoming King (2017)',
    "The King's Jester (2022)",
    'The Daily Show correspondent',
    "White House Correspondents' Dinner (2017)",
  ],
};

export default [
  {
    ...base,
    lang: 'en',
    nationality: 'American',
    shortBio: 'Political comedy meets personal storytelling',
    bio: `Hasan Minhaj is an American comedian, writer, and television host known for blending political commentary with deeply personal storytelling. His unique ability to discuss serious issues like immigration, politics, and identity while maintaining humor and authenticity has made him a distinctive voice in modern comedy.\n\nBorn in Davis, California to Indian Muslim immigrant parents, Minhaj studied political science before pursuing comedy. He gained recognition as a correspondent on "The Daily Show with Jon Stewart" before creating and hosting his own Netflix series "Patriot Act with Hasan Minhaj," which combined investigative journalism with comedy.\n\nMinhaj's stand-up specials, particularly "Homecoming King," showcase his talent for weaving personal experiences as a first-generation American with broader political and social commentary. His work addresses issues facing immigrant communities, the Muslim-American experience, and contemporary politics with intelligence, humor, and emotional depth.`,
    style: 'Political satire, personal storytelling, investigative comedy',
    achievements: [
      'Peabody Award',
      'Emmy Award',
      "White House Correspondents' Dinner host",
      'Time 100 most influential people',
      'Webby Awards',
      'Television Critics Association Award',
    ],
  },
  {
    ...base,
    lang: 'fr',
    nationality: 'Américain',
    shortBio: 'Comédie politique rencontre récit personnel',
    bio: `Hasan Minhaj est un comédien, écrivain et animateur de télévision américain connu pour mêler commentaire politique et récit profondément personnel. Sa capacité unique à discuter de questions sérieuses comme l'immigration, la politique et l'identité tout en maintenant humour et authenticité en fait une voix distinctive de la comédie moderne.\n\nNé à Davis, Californie, de parents immigrés musulmans indiens, Minhaj a étudié les sciences politiques avant de se tourner vers la comédie. Il s'est fait connaître comme correspondant de "The Daily Show with Jon Stewart" avant de créer et d'animer sa propre série Netflix "Patriot Act with Hasan Minhaj".\n\nSes specials stand-up, notamment "Homecoming King", montrent son talent pour tisser ses expériences personnelles en tant qu'Américain de première génération avec un commentaire politique et social plus large.`,
    style: 'Satire politique, récit personnel, comédie d\'investigation',
    achievements: [
      'Peabody Award',
      'Emmy Award',
      "Animateur du White House Correspondents' Dinner",
      'Time 100 personnalités les plus influentes',
      'Webby Awards',
      'Television Critics Association Award',
    ],
  },
  {
    ...base,
    lang: 'es',
    nationality: 'Americano',
    shortBio: 'Comedia política encuentra narrativa personal',
    bio: `Hasan Minhaj es un comediante, escritor y presentador de televisión estadounidense conocido por combinar el comentario político con una narración profundamente personal. Su capacidad única para discutir temas serios como la inmigración, la política y la identidad mientras mantiene el humor y la autenticidad lo convierte en una voz distintiva en la comedia moderna.\n\nNacido en Davis, California, de padres inmigrantes musulmanes indios, Minhaj estudió ciencias políticas antes de dedicarse a la comedia. Ganó reconocimiento como corresponsal en "The Daily Show with Jon Stewart" antes de crear y presentar su propia serie de Netflix "Patriot Act with Hasan Minhaj".\n\nSus especiales de stand-up, particularmente "Homecoming King", muestran su talento para entrelazar experiencias personales como americano de primera generación con un comentario político y social más amplio.`,
    style: 'Sátira política, narración personal, comedia de investigación',
    achievements: [
      'Peabody Award',
      'Emmy Award',
      "Presentador de la cena de corresponsales de la Casa Blanca",
      'Time 100 personas más influyentes',
      'Webby Awards',
      'Television Critics Association Award',
    ],
  },
  {
    ...base,
    lang: 'ar',
    nationality: 'أمريكي',
    shortBio: 'الكوميديا السياسية تلتقي بالسرد الشخصي',
    bio: `حسن منهاج كوميدي وكاتب ومقدّم تلفزيوني أمريكي اشتُهر بالجمع بين التعليق السياسي والرواية الشخصية العميقة. قدرته الفريدة على تناول قضايا جدية كالهجرة والسياسة والهوية مع الحفاظ على الفكاهة والأصالة جعلت منه صوتًا متميزًا في الكوميديا الحديثة.\n\nوُلد في ديفيز بكاليفورنيا لأبوين مهاجرَين مسلمَين من الهند، ودرس العلوم السياسية قبل التوجه إلى الكوميديا. اكتسب شهرته مراسلاً في "The Daily Show with Jon Stewart" قبل أن يبتكر ويقدّم مسلسله الخاص على Netflix "Patriot Act with Hasan Minhaj".\n\nعروضه الخاصة، لا سيما "Homecoming King"، تُظهر موهبته في نسج تجاربه الشخصية بوصفه أمريكيًا من الجيل الأول ضمن تعليق سياسي واجتماعي أوسع.`,
    style: 'ساخر سياسي، رواية شخصية، كوميديا استقصائية',
    achievements: [
      'Peabody Award',
      'Emmy Award',
      'مضيف حفل عشاء مراسلي البيت الأبيض',
      'قائمة Time 100 للشخصيات الأكثر تأثيرًا',
      'Webby Awards',
      'Television Critics Association Award',
    ],
  },
];
